import {createContext} from 'react';

/**
 * Runs before a dialog closes from its close button, Escape or an overlay click. Returns `true`
 * to keep the dialog open; `close` closes it later past the guard, for example after a confirm.
 */
export type DialogCloseGuard = (close: () => void) => boolean;

export interface DialogCloseGuardContextValue {
  /** One guard per dialog; `null` removes it. */
  setGuard: (guard: DialogCloseGuard | null) => void;
  /** Closes the dialog the way its close button does, so the guard runs first. */
  requestClose: () => void;
}

export const DialogCloseGuardContext = createContext<DialogCloseGuardContextValue | null>(null);
